export default __webpack_public_path__ + "static/media/sunsculpted13.6c352e0e.jpg";